import { observer } from 'mobx-react';
import React, { useContext } from 'react';

import { useI18n } from '../../../../../../../../application/language/useI18n';
import { PassingContext } from '../../../../PassingContext';
import { PassingSidebarAccordion } from '../PassingSidebarAccordion';
import { PassingTheoryAccordionContent } from './PassingTheoryAccordionContent';

export const PassingSidebarTheory = observer(() => {
  const { translate } = useI18n();
  const { passingDomain, theoryDomain, redirectToStep } = useContext(PassingContext);

  if (!theoryDomain.ui.isEnebled.value) {
    return <></>;
  }

  return (
    <PassingSidebarAccordion
      onChange={passingDomain.theoryDomain.expandHandler}
      isExpanded={passingDomain.theoryDomain.ui.isExpanded.value}
      onClick={(e) => {
        redirectToStep(e, 'theory');
      }}
      title={translate('phrases.theory')}
      timeLimitLabel={`30 ${translate('phrases.min')}`}
    >
      {passingDomain.theoryDomain.ui.navigationList.list.map((chapter, index) => {
        return (
          <PassingTheoryAccordionContent
            key={index}
            isActiveStep={passingDomain.theoryDomain.ui.activeStep.value === index ? true : false}
            title={chapter.title}
            isActive={chapter.isActive}
            passed={chapter.passed}
            subHeader={chapter.subHeader}
            navigationRedirect={chapter.navigationRedirect}
            data-cy={`data-cy-${chapter.title}`}
            hash={passingDomain.theoryDomain.ui.hash.value}
            scrollToAnchor={passingDomain.theoryDomain.scrollToAnchor}
            activeAccordionTitle={passingDomain.theoryDomain.ui.activeAccordionTitle.value}
            onExpandIconClick={passingDomain.theoryDomain.onExpandIconClick}
            dataCy={chapter.title}
          />
        );
      })}
    </PassingSidebarAccordion>
  );
});
